/**
 * @typedef {Record<string, number | null | undefined>} SummableObject
 */

/**
 * @param {SummableObject | undefined} stats
 */
export const statsCounter = (stats) => {
  let counter = 0
  if (!stats) {
    return null
  }
  Object.keys(stats).forEach((stat) => {
    if (typeof stats[stat] === 'number') {
      counter += stats[stat]
    }
  })
  return counter
}

export const channelTotals = ({ channel, type, stats }) => {
  const channelShares = stats.filter((shares) => shares.channel === channel)
  const channelTypes = channelShares.map((shares) => shares[type])
  let total = 0
  channelTypes.forEach((share) => (total += statsCounter(share) || 0))
  return total
}

export const emailTotals = ({ type, stats }) => {
  const channelShares = stats.filter((shares) => shares.channel === 'email')
  let total = 0
  channelShares.forEach((share) => {
    if (share.email[type]) {
      total += share.email[type]
    }
  })
  return total
}

/**
 * @param {{
 *  views?: SummableObject
 *  actions?: SummableObject
 *  clicks?: SummableObject
 * }[] | undefined} shares
 */
export const campaignTotals = (shares) => {
  const cache = {
    totals: {
      views: null,
      actions: null,
      clicks: null,
    },

    itemized: {
      views: {},
      actions: {},
      clicks: {},
    },
  }

  if (shares) {
    shares.forEach((share) => {
      tallyItemizedAndTotals(share, 'views', cache)
      tallyItemizedAndTotals(share, 'actions', cache)
      tallyItemizedAndTotals(share, 'clicks', cache)
    })
  }

  return cache
}

function tallyItemizedAndTotals(share, countableType, cache) {
  if (!share[countableType]) {
    return
  }

  for (const key in share[countableType]) {
    const value = share[countableType][key]

    if (typeof value !== 'number') {
      continue
    }

    if (cache.itemized[countableType][key] == null) {
      cache.itemized[countableType][key] = 0
    }

    cache.itemized[countableType][key] += value
    cache.totals[countableType] += value
  }
}

//This data will only work with campaignId f107d64449112 and brand slug testlio
export const sharesStub = [
  {
    data: {
      shares: [
        {
          id: '1185',
          channel: 'facebook',
          views: {
            impressions_organic: 5,
          },
          actions: {
            post_reaction_likes: 6,
            comments: 3,
            posts: 6,
          },
          clicks: {
            clicks: 9,
          },
        },
        {
          id: '1159',
          channel: 'facebook',
          views: {
            impressions_organic: 5,
          },
          actions: {
            post_reaction_likes: 4,
            comments: 8,
            posts: 6,
          },
          clicks: {
            clicks: 9,
          },
        },
        {
          id: '790',
          channel: 'twitter',
          actions: {
            favorites: 3,
            retweets: 6,
            clicks: 9,
          },
          clicks: {
            clicks: 9,
          },
        },
        {
          id: '789',
          channel: 'twitter',
          actions: {
            favorites: 3,
            retweets: 6,
            clicks: 11,
          },
          clicks: {
            clicks: 11,
          },
        },
        {
          id: '11',
          channel: 'email',
          clicks: {
            clicks: 11,
          },
          views: {
            opened: 55,
          },
          email: {
            bounced: 56,
          },
        },
        {
          id: '12',
          channel: 'email',
          clicks: {
            clicks: 23,
          },
          views: {
            opened: 55,
          },
          email: {
            bounced: 43,
          },
        },
        {
          id: '13',
          channel: 'email',
          clicks: {
            clicks: 55,
          },
          views: {
            opened: 55,
          },
          email: {
            bounced: 44,
          },
        },
      ],
    },
  },
]
